import { useNavigate } from 'react-router-dom';

export default function Rooms() {
  const navigate = useNavigate();

  const rooms = [
    {
      title: 'AC Room',
      description: 'Experience ultimate comfort with our air-conditioned rooms, perfect for a relaxing stay.',
      image: 'https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/831698e3dd612e98b8a12fa897f3ef92.jpeg',
      features: [
        'Air Conditioning',
        'Comfortable Bed',
        'Attached Bathroom',
        'TV & WiFi',
        'Room Service'
      ]
    },
    {
      title: 'Non-AC Room',
      description: 'Budget-friendly rooms with excellent ventilation and all essential amenities.',
      image: 'https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/7a7dcb37cf52d553af4f878eb45f0857.jpeg',
      features: [
        'Well Ventilated',
        'Comfortable Bed',
        'Attached Bathroom',
        'Fan & Lighting',
        'Clean & Spacious'
      ]
    }
  ];

  return (
    <section id="rooms" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Rooms
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Choose from our selection of well-appointed rooms designed for your comfort
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {rooms.map((room, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div 
                className="relative h-64 w-full cursor-pointer" 
                onClick={() => navigate('/')}
              >
                <img
                  src={room.image}
                  alt={room.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{room.title}</h3>
                <p className="text-gray-600 text-sm mb-4">{room.description}</p>
                <ul className="space-y-2 mb-6">
                  {room.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-emerald-600 mr-2 w-4 h-4 flex items-center justify-center"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button className="w-full px-6 py-3 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap">
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
